/*
  Version 1.0.1
  From M2 Mobile /component/Common/Table
*/

import classNames from 'classnames';

/**
 * build table helper
 * @param {object} props 
 * @param {array} props.data *required 用來顯示表格的資料 
 * @param {*} props.caption 表格title
 * @param {string} props.wrapClassName 表格客製classname
 * @returns 
 */
function Table(props){
  const {data, caption, wrapClassName} = props;

  const buildTable = () => {
    return (
      <>
          {data.map((row, i)=>{
            return (
              <tr 
                key={i}
              >
                {row.map((cell,j)=>{
                  let dynamicProps = {};
                  dynamicProps = {};
                  const hasSpanSetting = Array.isArray(cell);
                  const cellContent = hasSpanSetting ? cell[0] : cell
                  
                  if(hasSpanSetting){
                    const [attr, value] = cell[1].split(" ")
                    dynamicProps[attr] = value
                  }

                  if(i===0){ 
                    return <th key={j} {...dynamicProps}>{cellContent}</th>;
                  }else{
                    return (
                      <td key={j} {...dynamicProps}>{cellContent}</td>
                    );
                  }
                })}
              </tr>
            );
          })}
      </>
    );
  };

  return (
    <table 
      className={classNames({
        table_container: true,
        [wrapClassName]: wrapClassName
      })}
    >
      {caption && <caption>{caption}</caption>}
      {buildTable()}
    </table>
  );
}
export default Table;